import { createUseStyles } from 'react-jss'
import { global } from '../../theme'

export default createUseStyles({
  ...global,
})
